// device.service.ts

import { Injectable } from '@angular/core';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { environment } from '../../environments/environment';
//import UAParser from 'ua-parser-js';

export interface DeviceLabel {
  device: string;         // e.g., "iPhone", "macOS", "Samsung Galaxy S8"
  browser: string;        // e.g., "Chrome"
  label: string;          // device + " (" + browser + ")"
}

export interface PlatformInfo {
  platform: string;   // 'iOS' | 'Android' | 'macOS' | 'Windows' | 'Linux' | 'Unknown'
  os_version: string;
  app_version: string;
  model?: string;
}

@Injectable({
  providedIn: 'root'
})

export class DeviceService {
  private deviceInfoPromise: Promise<string>;
  private deviceIdKey = 'device:id';

//private deviceId: string;
// Create parser

  constructor() {
    this.deviceInfoPromise = this.initDeviceInfo();
    //this.deviceId = this.getOrCreateDeviceId();
  }

  /**
   * Initializes device information and stores it in localStorage.
   * @returns A Promise that resolves to the device fingerprint.
   */
  private async initDeviceInfo(): Promise<string> {
    try {
      // Initialize an agent at application startup.
      const fp = await FingerprintJS.load();

      // Get the visitor identifier when you need it.
      const result = await fp.get();
      const deviceInfo = result.visitorId;
      localStorage.setItem('device_info', deviceInfo);  // used for json token
      return deviceInfo;
    } catch (error) {
      console.error('Error obtaining device fingerprint:', error);
      throw error;
    }
  }

  /**
   * Retrieves the device information.
   * @returns A Promise that resolves to the device fingerprint.
   */
  getDeviceInfo(): Promise<string> {
    return this.deviceInfoPromise;
  }

 generateUUID(): string {
  if (crypto && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }
  // Fallback — browser-safe UUID
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = crypto.getRandomValues(new Uint8Array(1))[0] & 15;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}


  getOrCreateDeviceId(): string {
  let id = localStorage.getItem(this.deviceIdKey);
  if (!id) {
    //id = `device:${crypto.randomUUID()}`; // modern browsers
    id = `device:${this.generateUUID()}`;
    
    console.log("!!Generated new device ID: " + id);
    localStorage.setItem(this.deviceIdKey, id);
  }
  return id.replace(/^device:/, '');
  }

  private detectPlatform(): string {
    const ua = navigator.userAgent || navigator.vendor || (window as any).opera;

    if (/android/i.test(ua)) return 'Android';
    if (/iPad|iPhone|iPod/.test(ua) && !(window as any).MSStream) return 'iOS';
    if (/Win/i.test(ua)) return 'Windows';
    if (/Mac/i.test(ua)) return 'macOS';
    if (/Linux/i.test(ua)) return 'Linux';
    return 'Unknown';
  }

  private detectOSVersion(): string {
    const ua = navigator.userAgent;
    let match;

    if (/Windows NT (\d+\.\d+)/.test(ua)) {
      match = /Windows NT (\d+\.\d+)/.exec(ua);
      return match ? `Windows ${match[1]}` : 'Windows';
    }
    if (/Android (\d+([._]\d+)*)/.test(ua)) {
      match = /Android (\d+([._]\d+)*)/.exec(ua);
      return match ? `Android ${match[1]}` : 'Android';
    }
    if (/OS (\d+([._]\d+)*) like Mac OS X/.test(ua)) {
      match = /OS (\d+([._]\d+)*) like Mac OS X/.exec(ua);
      return match ? `iOS ${match[1].replace(/_/g, '.')}` : 'iOS';
    }
    if (/Mac OS X (\d+([._]\d+)*)/.test(ua)) {
      match = /Mac OS X (\d+([._]\d+)*)/.exec(ua);
      return match ? `macOS ${match[1].replace(/_/g, '.')}` : 'macOS';
    }
    if (/Linux/.test(ua)) {
      return 'Linux';
    }
    return 'Unknown';
  }

  private detectModel(): string {
    const ua = navigator.userAgent;
    if (/iPhone/.test(ua)) return 'iPhone';
    if (/iPad/.test(ua)) return 'iPad';
    if (/Pixel/.test(ua)) return 'Google Pixel';
    if (/Samsung/.test(ua)) return 'Samsung';
//    return 'Generic';
    return ua;
  }

  /** Public method that collects and returns platform info */
  public getPlatformInfo(): PlatformInfo {
    return {
      platform: this.detectPlatform(),
      os_version: this.detectOSVersion(),
      app_version: environment.appVersion,
      model: this.detectModel()
    };
  }

  public getDeviceName(): string {  
     return '';
  }    
}